module.exports = __webpack_public_path__ + "145fc655bfbfdf4e2ee50160595ba7b0.png";